module.exports = __webpack_public_path__ + "static/media/People.93c04226.svg";